import { z } from "zod";

export const executionSourceSchema = z.enum(["PackagingCreation", "Import", "Dim"]);
